import { memo } from 'react';

import { Image } from '@/shared/ui';

import { UserServiceExternal } from '@/api/types';

import { LinkAsButton } from '../../Button';
import { ModalBorderTopColor, ModalConstructor } from '../ModalConstructor';

import './ExternalServiceDetailsAlert.scss';

export interface ExternalServiceDetailsAlertProps {
  service: UserServiceExternal;
}

export const ExternalServiceDetailsAlert = memo<ExternalServiceDetailsAlertProps>(function ExternalServiceDetailsAlert({
  service,
}) {
  return (
    <ModalConstructor modalBorderTopColor={ModalBorderTopColor.red}>
      <div className="external-service-alert">
        <Image src={service.icon} alt="service-icon" />
        <div className="external-service-alert__header">{service.name}</div>

        <div className="external-service-alert_body">{service.short_description}</div>

        <div className="external-service-alert__buttons-box">
          <LinkAsButton to={service.link} size="lg" outline withIcon>
            <span>Перейти</span>
            <Image src="/images/arrow_right_blue.svg" alt="redirect" />
          </LinkAsButton>
        </div>
      </div>
    </ModalConstructor>
  );
});
